import { createAction, props } from '@ngrx/store';
import { PostCardData, TabClickEvent } from '@planone/bau365/util-fair-data';
import { FlatLinkClickEvent } from '@planone/shared/util-interfaces';

export const postsShareButtonClicked = createAction(
  '[Posts Page] Social share',
  props<{ network: string; post: PostCardData; exhibitorName: string; pageContext: string; context: string }>()
);

export const postsShareDialogOpened = createAction(
  '[Posts Page] Social share dialog ',
  props<{ contentType: string; pageContext: string; context: string; post: PostCardData }>()
);

export const postsTrackedItemClicked = createAction('[Posts Page] Tracked item clicked', props<FlatLinkClickEvent>());

export const postsTabClicked = createAction('[Posts Page] Tab option clicked', props<TabClickEvent>());

export const postsPageView = createAction('[Posts Page] Page view', props<{ post_id: string; fair_id: string }>());
